import React from 'react';

interface AlertProps {
  icon?: 'warning' | 'error' | 'calendar' | 'success' | null;
  variant?: 'info' | 'warning' | 'error' | 'success';
}

export const Alert = ({
  children,
  icon = null,
  variant = 'error'
}: React.PropsWithChildren<AlertProps>) => {

  // Map icon prop to xlinkHref values
  const getIconHref = (iconType: 'warning' | 'error' | 'calendar' | 'success'): string => {
    const iconMap: Record<'warning' | 'error' | 'calendar' | 'success', string> = {
      warning: '#warning-icon',
      error: '#alert-icon',
      calendar: '#icon-calendar',
      success: '#icon-checkmark'
    };
    return iconMap[iconType];
  };

  // Get the CSS class based on variant
  const getAlertClass = (variant: 'info' | 'warning' | 'error' | 'success'): string => {
    return `alert alert-${variant}`;
  };

  const iconHref = icon ? getIconHref(icon) : null;

  return (
    <div className={getAlertClass(variant)}>
      <div className="alert-inner">
        {icon && (
          <svg className="svg-icon" aria-hidden="true" focusable="false">
            <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref={iconHref} />
          </svg>
        )}
        <div className="alert-content">
          {children}
        </div>
      </div>
    </div>
  );
};